import PropTypes from "prop-types";

const Client_Frame = ({ className = "" }) => {
  return (
    // <div
    //   className={`w-[1660px] flex flex-row items-start justify-start flex-wrap content-start gap-x-8 gap-y-[25px] h-[910px] ml-[67px] text-left text-11xl text-deepskyblue-200 font-istok-web ${className}`}
    // >
    //   <div className="w-[1650px] flex flex-col items-center justify-start gap-[25px]">
    //     <b className="w-[125px] relative leading-[100%] uppercase inline-block h-[30px] shrink-0">
    //       Clients
    //     </b>
    //     <div className="self-stretch relative text-10xl leading-[130%] capitalize text-gray-200 text-center [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]">{`We pride ourselves on the long-lasting relationships we've built with a diverse range of clients. From startups to well-established corporations, our clients trust us to deliver exceptional talent. `}</div>
    //   </div>
    //   <div className="w-[1650px] flex flex-row items-start justify-center flex-wrap content-start gap-8">
    //     <img
    //       className="w-[276px] relative max-h-full object-cover"
    //       alt=""
    //       src="/irr-1@2x.png"
    //     />
    //     <img
    //       className="w-60 relative max-h-full object-cover"
    //       alt=""
    //       src="/motilal-oswal-1@2x.png"
    //     />
    //     <img
    //       className="w-[241px] relative max-h-full object-cover"
    //       alt=""
    //       src="/chola-1@2x.png"
    //     />
    //     <img
    //       className="w-[389px] relative max-h-full object-cover"
    //       alt=""
    //       src="/images-1@2x.png"
    //     />
    //     <img
    //       className="w-[251px] relative max-h-full object-cover"
    //       alt=""
    //       src="/CreditWise.jpg"
    //     />
    //     <img
    //       className="w-[304px] relative max-h-full object-cover"
    //       alt=""
    //       src="/scogoanytime-1@2x.png"
    //     />
    //     <img
    //       className="w-[174px] relative max-h-full object-cover"
    //       alt=""
    //       src="/hinduja-1@2x.png"
    //     />
    //     <img
    //       className="w-[228px] relative max-h-full object-cover"
    //       alt=""
    //       src="/iifl-1@2x.png"
    //     />
    //     <img
    //       className="w-[238px] relative max-h-full object-cover"
    //       alt=""
    //       src="/sarvaswa-digital-logo-1@2x.png"
    //     />
    //     <img
    //       className="w-[386px] relative max-h-full object-cover"
    //       alt=""
    //       src="/mirainform-1@2x.png"
    //     />
    //     <img
    //       className="w-[191px] relative max-h-full object-cover"
    //       alt=""
    //       src="/bf-broking-1@2x.png"
    //     />
    //     <img
    //       className="w-[301px] relative max-h-full object-cover"
    //       alt=""
    //       src="/HKKR.jpg"
    //     />
    //   </div>
    // </div>

    <div className="mt-12">
      <div className="text-center font-bold text-deepskyblue-200 text-12xl">
        CLIENTS
      </div>

      <div className="text-3xl text-center text-black">
        We pride ourselves on the long-lasting relationships we've built with a
        diverse range of clients. From startups to well-established
        corporations, our clients trust us to deliver exceptional talent.
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-12">
        <img className="w-80" alt="" src="/irr-1@2x.png" />
        <img className="w-80" alt="" src="/motilal-oswal-1@2x.png" />
        <img className="w-80" alt="" src="/chola-1@2x.png" />
        <img className="w-80" alt="" src="/images-1@2x.png" />
        <img className="w-80" alt="" src="/CreditWise.jpg" />
        <img className="w-80" alt="" src="/scogoanytime-1@2x.png" />
        <img className="w-80" alt="" src="/hinduja-1@2x.png" />
        <img className="w-80" alt="" src="/iifl-1@2x.png" />
        {/* <img className="w-80" alt="" src="/sarvaswa-digital-logo-1@2x.png" /> */}
        <img className="w-80" alt="" src="/mirainform-1@2x.png" />
        <img className="w-80" alt="" src="/bf-broking-1@2x.png" />
        <img className="w-80" alt="" src="/HKKR.jpg" />
        {/* <img className="w-80" alt="" src="/eYatra.jpg" /> */}
        <img className="w-80" alt="" src="/ResurgentIndia.png" />
        <img className="w-80" alt="" src="/Lenden.jpg" />
      </div>
    </div>
  );
};

Client_Frame.propTypes = {
  className: PropTypes.string,
};

export default Client_Frame;
